export const SET_RESULTS = "SET_RESULTS";
export const SET_LIVESCORE = "SET_LIVESCORE";
